import React from "react";
import { LandingZoneRoles } from "@store/types";
import { State, getLandingZoneRoles } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data = {
  error: Error | null;
  fetching: boolean;
  value: LandingZoneRoles;
};

export function useLandingZoneRoles(): Data {
  const dispatch = useDispatch();
  const [landingZoneRoles, error, fetching] = useSelector((state: State) => [
    state.landingZoneRoles,
    state.network.error.landingZoneRoles,
    state.network.fetching.landingZoneRoles,
  ]);

  React.useEffect(() => {
    if (!landingZoneRoles && !error && !fetching) {
      dispatch(getLandingZoneRoles());
    }
  }, [dispatch, landingZoneRoles, error, fetching]);

  return {
    error,
    fetching,
    value: landingZoneRoles,
  };
}
